<template>
    <window-portal :open="dataProps.show">
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center>
                <div>
                    <p style="font-size: 30px;">Vista previa de Estado de cuenta</p>
                </div>
            </center>
            <br />
            <center>
                <button class="btnclean" style="font-size: 18px;" @click="Print()">
                    Imprimir
                </button>
                &nbsp;&nbsp;
                <button class="btnclean" style="font-size: 18px;" @click="Download()">
                    Descargar
                </button>
            </center>
            <center>
                <div v-if="loading">
                    <p>Cargando...</p>
                </div>
            </center>

        </div>
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center v-if="mailLabel">
                {{ mailLabel }}
            </center>
        </div>

        <div class="book"
            style="margin: 0; padding: 0; background-color: rgb(105, 105, 105); font-family: arial !important; padding-top: 20px; padding-bottom: 20px;">
            <div style="display: flex; justify-content: space-around; ">
                <div ref="dataprint" style="margin: 0 !important; padding: 0 !important;">
                    <!--div style="position: relative; width: 1000px; min-height: 1294px; background: white;"-->
                    <div v-for="(page, indexPage) in pages" :key="indexPage"
                        style="position: relative; height: 1000px; min-width: 1293px; background: white;">
                        <hr />
                        <div class="subpage" style="height: 1250px; padding-top: 20px; overflow: hidden;">
                            <div style="margin-left: 80px; margin-right: 50px;">
                                <div style=" font-size: 12px;">
                                    <!-- <hr />
                                    <hr /> -->
                                    <div>
                                        <span style="text-transform: uppercase; font-weight: 550; font-size: 14pt;">{{ dataProps.header.business.BusinessName }}</span>
                                        <br>
                                        <b>
                                            {{ dataProps.header.title }}
                                        </b>
                                        <!-- <p style="margin-top: 20px ;">Fecha de Emisión : {{ dataProps.header.cutDate }}
                                        </p> -->
                                    </div>
                                </div>

                                <!-- Heres is teh body -->
                                <div style="width: 100%;">
                                    <table style="width: 100% !important; font-size: 11px; border-collapse: collapse; ">
                                        <tr>
                                            <td colspan="14">

                                                <hr />

                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="padding-left: 2px;text-align: left;">Código generación</td>
                                            <td style="padding-left: 2px;text-align: left;">No. Documento</td>
                                            <td style="padding-left: 2px;text-align: left;">Nombre Legal</td>
                                            <td style="padding-left: 2px;text-align: left;">Fecha de la Factura</td>
                                            <td style="padding-left: 2px;text-align: left;">Fecha de Pago</td>
                                            <td style="padding-left: 2px;text-align: end;">Total</td>
                                            <td style="padding-left: 2px;text-align: center;">Abonado</td>
                                            <td style="padding-left: 2px;text-align: end;">Saldo</td>
                                            <td style="padding-left: 2px;text-align: end;">Saldo de 30 días</td>
                                            <td style="padding-left: 2px;text-align: end;">Saldo de 60 días</td>
                                            <td style="padding-left: 2px;text-align: end;">Saldo de 90 días</td>
                                            <td style="padding-left: 2px;text-align: end;">Saldo de 120 días</td>
                                            <td style="padding-left: 2px;text-align: end;">Saldo de mas de 120 días</td>
                                        </tr>
                                        <tr>
                                            <td colspan="14">
                                                <hr />
                                            </td>
                                        </tr>
                                        <tr v-for="(item, index) in valuesRows[indexPage]" :key="index">
                                            <td style="padding: 4px;text-align: left">{{ item.ID_PurchaseLegalInvoiceNumber }}</td>
                                            <td style="padding: 4px;text-align: left;">{{ item.ID_PurchaseOrder }}</td>
                                            <td style="padding: 4px;text-align: left;">{{ item.ProviderLegalName }}</td>
                                            <td style="padding: 4px;text-align: left;">{{ item.PurchaseInvoiceDate }}</td>
                                            <td style="padding: 4px;text-align: left;">{{ item.fecha_vencimiento }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.total }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.abonado }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.saldo }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.saldo_30 }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.saldo_60 }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.saldo_90 }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.saldo_120 }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.saldo_mas_120 }}</td>
                                        </tr>
                                    </table>
                                    <br />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </window-portal>
</template>

<script>

import jsPDF from "jspdf"
import 'jspdf-autotable'
//import QRCode from 'qrcode';
//import html2canvas from "html2canvas"
import WindowPortal from "@/components/ReportsAndPrintings/WindowPortal.vue"

export default {
    name: "PrintAccountsPayableStatement",
    props: ['dataProps'],
    components: { WindowPortal },
    data() {
        return {
            header: null,
            footer: null,
            loading: false,
            //seal: "",
            //sealBranch: "",
            numPages: 0,
            Currency: JSON.parse(localStorage.getItem('branch')).Currency || '',
            //valuesRows: []
            mailLabel: null,
            valuesRows: [],
            urlQr: null,
            typePrint: 0,
            margins: {
                top: 40,
                bottom: 40,
                left: 40,
                right: 40
            },
            currentY: 40
        }
    },
    mounted() {
        this.calculatePagesOfDoc();
    },
    computed: {
        pages() {
            // Generar un arreglo con `numPages` elementos
            return Array.from({ length: this.numPages });
        },
    },
    watch: {
        'dataProps.show'() {
            if (this.dataProps.show) {
                setTimeout(async () => {
                    await this.calculatePagesOfDoc()
                }, 0);
            }
        },
        'dataProps'() {
            this.calculatePagesOfDoc()
        }
    },
    methods: {
        calculatePagesOfDoc() {
            let pages = 0
            let rows = 0
            this.valuesRows[pages] = []

            try {
                this.typePrint = 0
                //Cuando es solo una página
                if (this.dataProps.data.body.length <= 25) {
                    for (let i = 0; i < this.dataProps.data.body.length; i++) {
                        rows++
                        this.valuesRows[pages].push(this.dataProps.data.body[i])

                    }
                }
                else {
                    for (let i = 0; i < this.dataProps.data.body.length; i++) {
                        if (rows < 25 && (i !== this.dataProps.data.body.length - 1)) {
                            rows++
                            this.valuesRows[pages].push(this.dataProps.data.body[i])
                        }
                        else if (rows <= 3) {
                            rows++
                            this.valuesRows[pages].push(this.dataProps.data.body[i])

                        }
                        else {
                            this.valuesRows[pages].push(this.dataProps.data.body[i])
                            pages++
                            rows = 0
                            this.valuesRows[pages] = []
                        }
                    }
                }
            }
            catch (err) {
                alert(err)
            }
            // pages = pages + 1

            this.numPages = pages === 0 ? 1 : pages;
        },

        configDoc() {
            const doc = new jsPDF('landscape', 'pt', 'letter');
            const headers = [[
                'Código generación',
                'No. Documento',
                'Nombre Legal',
                'Fecha de la Factura',
                'Fecha de Pago',
                'Total',
                'Abonado',
                'Saldo',
                'Saldo de 30 días',
                'Saldo de 60 días',
                'Saldo de 90 días',
                'Saldo de 120 días',
                'Saldo de mas de 120 días',
            ]];
            const body = this.dataProps.data.body.map(element => {
                return [
                    element.ID_PurchaseLegalInvoiceNumber,
                    element.ID_PurchaseOrder,
                    element.ProviderLegalName,
                    element.PurchaseInvoiceDate,
                    element.fecha_vencimiento,
                    element.total,
                    element.abonado,
                    element.saldo,
                    element.saldo_30,
                    element.saldo_60,
                    element.saldo_90,
                    element.saldo_120,
                    element.saldo_mas_120,
                ]
            });

            doc.autoTable({
                startY: this.currentY,
                margin: { 
                    top: this.currentY,
                    left: 10, 
                    right: 10, 
                    bottom: 20 
                },
                willDrawPage: function (data) {
                    doc.setFontSize(10);
                    doc.setTextColor(40);
                    doc.setFont("helvetica", "bold");
                    const { business = "", } = JSON.parse(localStorage.getItem("user"));
                    doc.text(`${(business || '').toUpperCase()}`, data.settings.margin.left, 22).setFontSize(11);
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(9);
                    doc.text(`Reporte de estado de cuentas `, data.settings.margin.left, 34);
                },
                head: headers,
                body: body,
                theme: 'plain',
                headStyles: {
                    textColor: 0,
                    halign: 'left',
                    valign: 'middle',
                    lineWidth: {
                        top: 0.5,    // Borde arriba
                        bottom: 0.5, // Borde abajo
                        left: 0,     // Sin borde lateral
                        right: 0
                    },
                    lineColor: [0, 0, 0]
                },
                styles: { 
                    cellPadding: 1.5, 
                    fontSize: 6,
                    halign: 'right',
                    // valign: 'start'
                },
                columnStyles: {
                    0: { cellWidth: 100, halign: 'left', },
                    1: { cellWidth: 70, fontSize: 5, halign: 'left',},
                    2: { cellWidth: 90, fontSize: 5, halign: 'left',},
                    3: { halign: 'left',},
                    4: { halign: 'left',},
                },
            })
            return doc;
        },

        async Print() {
            this.loading = true
            const doc = this.configDoc();
            //doc.deletePage(2)

            doc.autoPrint({ variant: 'non-conform' });
            const blob = doc.output("bloburl")
            window.open(blob)

            this.loading = false
        },

        async Download() {
            this.loading = true
            const doc = this.configDoc();
            doc.save("Resumen Cuentas Por Cobrar.pdf")
            this.loading = false
        },
    }
}
</script>

<style scoped>
.u-row .u-col-100 {
    width: 100% !important;
}

.btnclean {
    border-radius: 15px;
    border: 1px solid white;
    background-color: #F29D35 !important;
    color: white !important;
}

.btnclose {
    border-radius: 15px;
    border: 1px solid white;
    background-color: rgb(255, 38, 38) !important;
    color: white !important;

}

* {
    font-family: Arial, Helvetica, sans-serif !important;
}
</style>
